interface ChildProps {
  children: React.ReactNode | React.ReactNode[]
  className?: string
}

interface TableProps {
  headers: string[]
  className?: string
  children: React.ReactNode | React.ReactNode[]
}

const Table = ({ headers, children, className }: TableProps) => {
  return (
    <div
      className={`relative overflow-x-auto rounded-lg shadow-md ${className}`}
    >
      <table className="w-full text-left text-sm rtl:text-right dark:text-gray-400">
        <thead className="bg-gray-800 text-xs text-gray-100">
          <tr>
            {headers?.map((header, index) => (
              <TableHeader key={index}>{header}</TableHeader>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white">{children}</tbody>
      </table>
    </div>
  )
}

const TableRow = ({ children, className }: ChildProps) => (
  <tr className={`border-b text-sm text-gray-900 ${className}`}>{children}</tr>
)

const TableHeader = ({ children }: ChildProps) => (
  <th scope="col" className="px-6 py-3">
    {children}
  </th>
)

const TableCell = ({ children }: ChildProps) => (
  <td className="px-6 py-4">{children}</td>
)

export { Table, TableRow, TableHeader, TableCell }
